import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faHouzz, faInstagram, faPinterest, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons'
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  icon: {
    padding: 6,
    fontSize: '.9rem',
    height: '1.6rem',
    width: '1.6rem',
    '&:hover': {
      color: 'white',
      fontSize: '1rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '.8rem',
      height: '1.2rem',
      width: '1.2rem',
  },
  }
});

const icons = [
  {link: "https://www.facebook.com/DirectBuy", icon: faFacebook},
  {link: "https://www.youtube.com/user/directbuy", icon: faYoutubeSquare},
  {link: "https://www.pinterest.com/DirectBuy", icon: faPinterest},
  {link: "https://www.houzz.com/pro/directbuyhq/", icon: faHouzz},
  {link: "https://www.instagram.com/directbuy_inc/", icon: faInstagram},
]

class SocialLinks extends React.Component {
  render() {
    const { classes } = this.props;

    return (
        <React.Fragment>
            {icons.map((icon, i) => <IconButton key={i} className={classes.icon} size='small' href={icon.link}><FontAwesomeIcon icon={icon.icon} /></IconButton>)}
        </React.Fragment>
    );
  }
}

SocialLinks.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SocialLinks);